// extracted by mini-css-extract-plugin
module.exports = {"host":"_1JSZYsK3HDfYHtlN1i7ofA","ctaButton":"_2osvhjv2PMpF-lkgGP8SeU","badge":"_1KQADr_5cC3Yrh3Q18LU4_"};